<!-- @format -->

@if (documentState === "DRAFT") {
  <sis-tiny-badge [variant]="'accent'"> {{ "VISIBLE_DOCUMENT_STATE.DRAFT" | translate }}</sis-tiny-badge>
}
@if (documentState === "DELETED") {
  <sis-tiny-badge [variant]="'danger'"> {{ "VISIBLE_DOCUMENT_STATE.DELETED" | translate }}</sis-tiny-badge>
}
